import { FC, SVGProps } from 'react';

const SLABreachedIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = 20,
  color = '#666666',
  height = 24,
  width = 24,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 17.4999C13.5268 17.4999 16.3851 14.6408 16.3851 11.1148C16.3851 7.588 13.5268 4.72974 10 4.72974C6.47398 4.72974 3.61572 7.588 3.61572 11.1148C3.61572 14.6408 6.47398 17.4999 10 17.4999Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M8.24878 2.5H11.7552" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M9.99341 11.092L12.4445 8.64087"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default SLABreachedIcon;
